import { NormalSelectOptions } from "@app/components/select/select.type";
import {
  ACCESS_TOKEN_KEY,
  DEFAULT_DATE_TIME_FORMAT,
  MobileOS,
  REFRESH_TOKEN_KEY,
  USER_INFO_KEY,
} from "@app/constants";
import StorageService from "@core/services/storage";
import dayjs from "dayjs";

export const clearLocalStorage = () => {
  StorageService.remove(ACCESS_TOKEN_KEY);
  StorageService.remove(REFRESH_TOKEN_KEY);
  StorageService.remove(USER_INFO_KEY);
};

export const formatMoneyVN = (
  money: number | string,
  options?: Intl.NumberFormatOptions
) => {
  return Intl.NumberFormat("vi-VN", options).format(Number(money));
};

export const generatePageList = (totalPage = 0) => {
  return Array(totalPage)
    .fill(0)
    .map((_, index) => ({
      label: String(index + 1),
      value: index + 1,
    })) as NormalSelectOptions;
};

export const fromUnixTime = (unixSeconds: number) => {
  return dayjs.unix(unixSeconds);
};

export const formatDateTime = (
  unixSeconds: number,
  format = DEFAULT_DATE_TIME_FORMAT
) => {
  return fromUnixTime(unixSeconds).format(format);
};

export const createObjectURL = (obj: Blob | MediaSource) => {
  return URL.createObjectURL(obj);
};

export const fancyTimeFormat = (duration: number) => {
  // Hours, minutes and seconds
  const hrs = ~~(duration / 3600);
  const mins = ~~((duration % 3600) / 60);
  const secs = ~~duration % 60;

  // Output like "1:01" or "4:03:59" or "123:03:59"
  let ret = "";

  if (hrs > 0) {
    ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
  }

  ret += "" + mins + ":" + (secs < 10 ? "0" : "");
  ret += "" + secs;

  return ret;
};

export const getMobileOperatingSystem = () => {
  const userAgent =
    navigator.userAgent || navigator.vendor || (<any>window).opera;

  if (/android/i.test(userAgent)) {
    return MobileOS.ANDROID;
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !(<any>window).MSStream) {
    return MobileOS.IOS;
  }

  return "";
};
